import { Component } from '@angular/core';
import { BulletinService, DeploymentBulletinRequest } from '../../../shared/services/bulletin.service';

@Component({
    selector: 'app-send-bulletin',
    templateUrl: './send-bulletin.component.html',
    styleUrls: ['./send-bulletin.component.css'],
    standalone: false
})
export class SendBulletinComponent {
  message = 'A system update is about to be deployed. Please save all your work before the countdown expires.';
  countdownMinutes = 5;
  isSending = false;
  lastResult: { success: boolean; text: string } | null = null;
  showConfirm = false;

  // Preset messages
  presets = [
    {
      label: 'Standard Deployment',
      message: 'A system update is about to be deployed. Please save all your work before the countdown expires.',
      minutes: 5
    },
    {
      label: 'Emergency Maintenance',
      message: 'Emergency maintenance is required. The system will be temporarily unavailable. Please save your work immediately.',
      minutes: 2
    },
    {
      label: 'Scheduled Downtime',
      message: 'Scheduled maintenance will begin shortly. The system will be unavailable for approximately 30 minutes. Please save your work.',
      minutes: 10
    }
  ];

  constructor(private bulletinService: BulletinService) {}

  applyPreset(preset: { label: string; message: string; minutes: number }): void {
    this.message = preset.message;
    this.countdownMinutes = preset.minutes;
  }

  promptSend(): void {
    if (!this.message.trim()) {
      this.lastResult = { success: false, text: 'Please enter a message.' };
      return;
    }
    this.showConfirm = true;
  }

  cancelSend(): void {
    this.showConfirm = false;
  }

  confirmSend(): void {
    this.showConfirm = false;
    this.isSending = true;
    this.lastResult = null;

    const request: DeploymentBulletinRequest = {
      message: this.message.trim(),
      countdownSeconds: this.countdownMinutes * 60
    };

    this.bulletinService.sendDeploymentBulletin(request).subscribe({
      next: (res) => {
        this.isSending = false;
        this.lastResult = {
          success: true,
          text: `Bulletin sent successfully to all connected users. Countdown: ${this.countdownMinutes} minute(s).`
        };
      },
      error: (err) => {
        this.isSending = false;
        const errorMsg = err?.error?.error || err?.message || 'Unknown error occurred.';
        this.lastResult = { success: false, text: `Failed to send bulletin: ${errorMsg}` };
      }
    });
  }
}
